import React, { useRef, useState } from "react";
import ButtonComponent from "./ButtonComponent";
import { axiosPrivate } from "../../api/axios";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/ddddot.json";
import { ReactComponent as Trash } from "../../iconColor/trash.svg";
import { ReactComponent as Upload } from "../../iconColor/upload.svg";
import { ReactComponent as FileImportOutline } from "../../iconColor/file-import-outline.svg";
import Swal from "sweetalert2";
import { USER_OCR_ID_CARD } from "../../api/apiClient";
import { toast } from "react-toastify";

interface UploderComponentProps {
    name?: any;
    onChange?: (file: any) => void;
    onRemove?: () => void;
    defaultValue?: any;
    errors?: any;
    OcrIdCard?: boolean;
    onResponse?: any;
    isLoading?: boolean;
    dontRemoveImage?: boolean;
    className?: any;
    loadingHeight?: any;
    setSelectedImage?: any;
    selectedImage?: any;
    isStoreImage?: boolean;
}

const UploderComponent: React.FC<UploderComponentProps> = ({
    name,
    onChange,
    defaultValue,
    errors,
    setSelectedImage,
    selectedImage,
    OcrIdCard = false,
    onResponse,
    isLoading,
    dontRemoveImage,
    onRemove,
    className,
    loadingHeight,
    isStoreImage = false,
}: any) => {
    const [formData, setFormData] = useState(new FormData());
    const access_token = localStorage.getItem("access_token");
    const fileInputRef = useRef<HTMLInputElement>(null);

    const [isClicked, setIsClicked] = useState(false);
    const [estelaming, setEstelaming] = useState(false);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        renderer: "svg",
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e?.target?.files?.[0];
        const maxSize = 3 * 1024 * 1024;

        if (file && file?.size > maxSize) {
            toast.warning("حجم فایل باید کمتر از 3 مگابایت باشد");
            e.target.value = "";
        } else if (file && !file.type.startsWith("image/")) {
            toast.error("فایل انتخاب شده باید تصویر باشد");
            e.target.value = "";
            setSelectedImage(undefined);
        } else if (file && file.type.startsWith("image/")) {
            const newFormData = new FormData();
            newFormData.append("id_card", file);
            setFormData(newFormData);

            const imageDataUrl = URL.createObjectURL(file);
            setSelectedImage(imageDataUrl);
        } else {
            setSelectedImage(undefined);
        }

        if (onChange) {
            onChange(file);
        } else {
            setFormData(new FormData());
        }
    };

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleInquiryClick = async () => {
        setEstelaming(true);
        setIsClicked(true);
        if (!formData.has("id_card")) {
            console.error("No file selected for upload");
            return;
        }

        try {
            const response = await axiosPrivate.post(USER_OCR_ID_CARD, formData, {
                headers: {
                    // prettier-ignore
                    "accept": "application/json",
                    // prettier-ignore
                    "Authorization": `Bearer ${access_token}`,
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            });

            if (response?.status >= 200 && response?.status < 300) {
                setEstelaming(false);
                setIsClicked(false);
                if (onResponse) {
                    onResponse(response.data);
                }
            } else {
                setEstelaming(false);

                setIsClicked(false);

                console.error(
                    "Error in request:",
                    response.data || response.statusText
                );
            }
        } catch (error) {
            setIsClicked(false);
            setEstelaming(false);

            console.error("An unexpected error occurred:", error);
        }
    };

    return (
        <div
            className={` ${className} ${errors
                ? "bg-red-100 rounded-lg border-2 border-red-300 border-dashed"
                : "flex hover:bg-gray-100 select-none rounded-lg border-2 border-gray-300 border-dashed bg-gray-50 p-4 items-center justify-center w-full h-[250px]"
                }`}
        >
            {(selectedImage || defaultValue) && !estelaming ? (
                <div
                    className={`shrink-0 grow-0 flex relative ${isStoreImage
                        ? "aspect-ratio-16-9-store-image"
                        : "aspect-ratio-16-9-store-image"
                        } w-full h-[230px]`}
                >
                    <img
                        src={selectedImage || defaultValue}
                        alt="Selected"
                        className={`${isStoreImage
                            ? "shrinkgrow absolute top-0 right-0 bottom-0 left-0 w-full h-[230px] object-cover"
                            : "shrinkgrow absolute top-0  right-0 bottom-0 left-0 w-full h-[220px] object-cover"
                            }`}
                    />

                    {!dontRemoveImage && (
                        <Trash
                            className="absolute cursor-pointer top-3 left-3 bg-white w-6 h-6 p-[2px] rounded-full"
                            onClick={() => {
                                if (onRemove) {
                                    Swal.fire({
                                        title: "از حذف کردن تصویر اطمینان دارید؟",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#477CD1",
                                        cancelButtonColor: "#F05252",
                                        confirmButtonText: "بله",
                                        cancelButtonText: "خیر",
                                        customClass: {
                                            confirmButton: "my-confirm-button",
                                            cancelButton: "my-cancel-button",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            setSelectedImage(undefined);
                                            onRemove();
                                        }
                                    });
                                }
                            }}
                        />
                    )}
                    {OcrIdCard && !defaultValue && (
                        <div className="absolute justify-center items-center flex sm:p-4 py-1 bg-[#ffffff70] bottom-0  w-full px-6">
                            <ButtonComponent
                                variant="filled"
                                bgColor="bg-primary-50"
                                textColor="text-primary-800"
                                className={`sm:w-full w-16 border border-primary-800 ${defaultValue ? " w-full cursor-not-allowed" : ""
                                    }`}
                                onClick={defaultValue ? () => { } : handleInquiryClick}
                            >
                                {isClicked ? (
                                    <Lottie options={defaultOptions} height={50} width={50} />
                                ) : (
                                    "استعلام"
                                )}
                            </ButtonComponent>
                        </div>
                    )}
                    <input
                        id={name}
                        type="file"
                        className="hidden"
                        name="id_card"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        accept="image/jpeg, image/png, image/jpg"
                    />
                </div>
            ) : estelaming ? (
                <>
                    <div className="shrink-0 grow-0 flex relative aspect-ratio-16-9 w-full h-auto">
                        <div className="absolute justify-center items-center flex sm:p-4 py-1 bg-[#ffffff70] inset-0  w-full px-6">
                            <div className="flex flex-col items-center justify-center">
                                <div className="text-BodyText/14/Regular text-[#6B7280]">
                                    در حال بررسی اطلاعات کارت ملی
                                </div>
                                <div className="flex items-center justify-center">
                                    <span className="text-primary-800">لطفا منتظر بمانید</span>
                                    <div className="p-2">
                                        <Lottie options={defaultOptions} height={50} width={50} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <input
                            id={name}
                            type="file"
                            className="hidden"
                            name="id_card"
                            onChange={handleFileChange}
                            ref={fileInputRef}
                            accept="image/jpeg, image/png, image/jpg"
                        />
                    </div>
                </>
            ) : (
                <label
                    htmlFor={name}
                    className={`flex flex-col items-center justify-center w-full ${errors ? "h-full" : "h-full"
                        } rounded-lg cursor-pointer`}
                >
                    {isLoading ? (
                        <div
                            className={`flex items-center justify-center gap-3 text-primary-500 ${loadingHeight ? loadingHeight : "h-52"
                                }`}
                        >
                            <span>در حال دریافت اطلاعات</span>
                            <Lottie options={defaultOptions} height={50} width={50} />
                        </div>
                    ) : (
                        <>
                            <div className="flex flex-col items-center justify-center w-full pt-5 pb-6 h-full">
                                <Upload width={"40px"} height={"40px"} />
                                <p className="my-2 mx-2 text-center">
                                    {errors ? (
                                        <span className="text-BodyText/14/Bold text-center text-red-600">
                                            انتخاب تصویر الزامی است.
                                        </span>
                                    ) : (
                                        <span className="text-BodyText/14/Bold text-center text-gray-600">
                                            برای آپلود کلیک کنید
                                        </span>
                                    )}
                                    <span className="text-gray-500 text-Title/14/Regular">
                                        {errors ? "" : "  یا فایل خود را بکشید و بیندازید"}
                                    </span>
                                </p>
                                <p className=" mb-4 text-gray-500 text-BodyText/12/Regular">
                                    {errors ? "" : "بیشترین سایز فایل: 5 مگابایت"}
                                </p>
                                <ButtonComponent
                                    hasIcon
                                    icon={<FileImportOutline />}
                                    onClick={handleButtonClick}
                                >
                                    انتخاب فایل
                                </ButtonComponent>
                            </div>
                            <input
                                id={name}
                                type="file"
                                className="hidden"
                                name="id_card"
                                onChange={handleFileChange}
                                ref={fileInputRef}
                                accept="image/jpeg, image/png, image/jpg"
                            />
                        </>
                    )}
                </label>
            )}
        </div>
    );
};

export default UploderComponent;
